import React, { Component } from 'react'
import Footer from '../components/Footer'
import Mainmenu from '../components/Mainmenu'
import Navbar from '../components/Navbar'
import TalentCategoryDetailsContent from './TalentCategoryDetailsContent'

export default class TalentCategoryDetails extends Component {
    render() {
        const id = this.props.match.params.id;
        return (
            <div className="wrapper">
                <Navbar />
                <Mainmenu />
                <TalentCategoryDetailsContent id={id} />
                <Footer />
            </div>
        )
    }
}
